<mat-toolbar class="mat-elevation-z1" [ngClass]="getNavClass()">
  <button
    mat-button
    fxShow.gt-xs
    class="language-button"
    [matMenuTriggerFor]="languageMenu">
    <div fxLayout="row" fxLayoutAlign="center center">
      <span class="iso text-uppercase language-title">{{
        selectedLanguage.id
      }}</span>
    </div>
  </button>
  <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
    @for (lang of languages; track lang) {
      <button mat-menu-item (click)="onLanguageToolbarChange(lang)">
        <span fxLayout="row" fxLayoutAlign="start center">
          <span class="iso">{{ lang.title }}</span>
        </span>
      </button>
    }
  </mat-menu>
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
      @if (isSmallScreen && isLoggedIn) {
        <button
          mat-icon-button
          class="navbar-toggle-button"
          (click)="toggleSidenav()">
          <mat-icon class="toolbar-icon">menu</mat-icon>
        </button>
      }
      @if (!isNotConnected && isLoggedIn) {
        <button
          mat-icon-button
          class="navbar-toggle-button"
          routerLink="/settings"
          routerLinkActive
          #rla="routerLinkActive"
          [disabled]="rla.isActive">
          <mat-icon class="toolbar-icon">settings</mat-icon>
        </button>
      }
      @if (isLoggedIn) {
        @if (hasMultiEtab) {
          <div class="field">
            <div class="box-container">
              @if (groupeEtablissement?.length < 10) {
                <mat-form-field appearance="fill" class="simplified">
                  <mat-select
                    class="select-etab-users"
                    [(ngModel)]="selectedEtablissement"
                    (selectionChange)="onEtablissementChange()">
                    @for (
                      etablissement of groupeEtablissement;
                      track etablissement
                    ) {
                      <mat-option [value]="etablissement">
                        {{ etablissement }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              } @else {
                <mat-form-field appearance="fill" class="simplified">
                  <mat-select
                    class="select-etab-users"
                    [(ngModel)]="selectedEtablissement"
                    (selectionChange)="onEtablissementChange()"
                    (closed)="onSelectClose()">
                    <div class="selectInputForm">
                      <mat-form-field>
                        <input
                          matInput
                          type="text"
                          [(ngModel)]="etabSearch"
                          placeholder="{{
                            'USERS.SETTINGS.TOOLBARSEARCH' | translate
                          }}"
                          (input)="onInputChange()"
                          class="etabInput" />
                      </mat-form-field>
                    </div>
                    @for (
                      etablissement of filteredOptions;
                      track etablissement
                    ) {
                      <mat-option [value]="etablissement">
                        {{ etablissement }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          </div>
        } @else {
          @if (groupeEtablissement?.length > 0) {
            <div class="box-container" style="margin-right: 10px">
              @for (
                etablissement of groupeEtablissement;
                track etablissement;
                let i = $index
              ) {
                <span class="singleEtab">
                  {{ etablissement }}
                </span>
              }
            </div>
          }
        }
      }
      <div>
        @if (isNotConnected) {
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxFlex="0 1 auto">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div
                class="help-icon"
                fxLayout="row"
                fxLayoutAlign="center center">
                <button
                  mat-icon-button
                  matTooltip="Support"
                  [routerLink]="['/assistance']">
                  <mat-icon class="secondary-text">help_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="main-logo"></div>
</mat-toolbar>
